<script setup lang="ts">
const { isOnSearchPage } = useNavigation()
const { navOmniBarTestId } = useTestId()
const { navOmniBarId } = useGlobals()
const { isInstantSearchOpen, isInstantSearchFocused } = useInstantSearch()
</script>

<template>
  <div class="omni-bar">
    <nav-pill
      :id="navOmniBarId"
      class="omni-bar-pill"
      :class="{ search: isInstantSearchFocused() }"
      :data-testid="navOmniBarTestId"
    >
      <nav-path v-if="!isOnSearchPage() && !isInstantSearchOpen()" />
      <nav-search v-else-if="isOnSearchPage() && !isInstantSearchOpen()" />

      <!-- TODO: change type based on type of search / path -->

      <nav-instant-search v-else-if="isInstantSearchOpen()" />
    </nav-pill>

    <!-- TODO: Remove when you're done implementing instant search -->
    <!-- <nav-instant-menu v-if="instantState.visible" /> -->
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.omni-bar
  @apply flex flex-shrink min-w-0

.omni-bar-pill
  @apply overflow-hidden p-[#{$pill-m-button}] pointer-events-auto z-navigation-layer
  &.search
    @apply outline outline-$global-blue-primary
    @include alphaShadow(var(--global-blue-accent), 0.5px, drop-shadow(-2px 1px 2px #10101040))
</style>
